import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-50 border-t border-secondary-200/50">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">V</span>
              </div>
              <span className="text-lg font-bold text-foreground-950 font-heading tracking-tight">
                Vigorbuy
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Your ultimate shopping guide with the best product finds, QC guides, and expert tips.
              Updated daily with trusted recommendations.
            </p>
          </div>

          {/* Shop Links */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Shop
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Hoodies &amp; Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Jackets
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Bags
                </a>
              </li>
            </ul>
          </div>

          {/* Guides Links */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Guides
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/vigorbuy-sheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Vigorbuy Sheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Latest Finds
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Legal
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Vigorbuy.blog. All rights reserved. We do not sell products directly.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:text-foreground-950 hover:bg-secondary-200 transition-colors cursor-pointer">
              <i className="ri-shopping-bag-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:text-foreground-950 hover:bg-secondary-200 transition-colors cursor-pointer">
              <i className="ri-external-link-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}